import { render, staticRenderFns } from "./FooterButton.vue?vue&type=template&id=5b5c055c&scoped=true&"
import script from "./FooterButton.vue?vue&type=script&lang=js&"
export * from "./FooterButton.vue?vue&type=script&lang=js&"
import style0 from "./FooterButton.vue?vue&type=style&index=0&id=5b5c055c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5c055c",
  null
  
)

export default component.exports